module.exports = __webpack_public_path__ + "static/hero-222aaa3ee036ca1495bd6aab678d7ea3.jpg";